import React from 'react';
import { Typography } from 'antd';
import { LayoutWithNav } from '../components/Layout';

const { Title } = Typography;

function Home() {
  return (
    <LayoutWithNav>
      <Title>Have a Great Day!</Title>
    </LayoutWithNav>
  );
}

export default Home;
